import React, { useState } from "react";
import { RequiredTheme, ResponsiveValue, ThemeValue } from "styled-system";
import { Accordion } from "../Accordion";

interface Props {
  title: string;
  titleFontSize?: ResponsiveValue<ThemeValue<"fontSizes", RequiredTheme>, RequiredTheme>;
}

export const ManagedAccordion: React.FC<Props> = ({ title, titleFontSize, children }) => {
  const [show, setShow] = useState<boolean>(false);

  const onClick = () => setShow(prevState => !prevState);

  return (
    <Accordion title={title} titleFontSize={titleFontSize} show={show} handleClick={onClick}>
      {children}
    </Accordion>
  );
};
